<template>
  <div class="refund-edit bgf6">
    <div class="detail">
      <img class="detail-tips-img" src="../../static/images/refund/img_sqtk@2x.png" alt="">
      <div class="detail-content">
        <div class="icm-title">
          <div class="prefix-icon"><img class="icon-img" src="../../static/images/refund/icon_tk_ks.png" alt="" srcset=""></div>
          <div class="label-content">{{data.batchName}}</div>
        </div>
        <div class="icm-content">
          <div class="content-left">{{data.specialtyName}}({{data.gradeName}})</div>
          <div class="content-right">
            ¥{{Number(data.refundFee || 0).toFixed(2)}}
          </div>
        </div>
      </div>
    </div>
    <van-empty class="empty" v-if="empty" :image="require('../../static/images/refund/refuse_refund@2x.png')" description="考试状态处于评分中/已评分 暂不支持退款"/>
    <van-form class="edit-form" v-if="!empty&&form" ref="form" label-width="100px" @submit="save()">
      <div class="form-box">
        <div style="color: #212B36; font-size: 0.48rem; font-weight: bold; display: flex; justify-content: space-between;">
          <div style="font-family: 'SourceHanSerifCN-Bold';">退款信息</div>
        </div>
        <div class="icm-label" style="margin-top:8px">
          <div class="label">退款金额</div>
          <div class="value active-color">¥{{Number(data.refundFee || 0).toFixed(2)}}</div>
        </div>
      </div>
      <div class="form-box">
        <div style="color: #212B36; font-size: 0.48rem; font-weight: bold; font-family: 'SourceHanSerifCN-Bold';">
          退款原因
        </div>
        <van-field
          v-model="form.refundReason"
          rows="4"
          autosize
          label=""
          type="textarea"
          maxlength="50"
          placeholder="请输入退款原因"
          show-word-limit
          style="border: 0.5px solid #ebedf0; margin-top: 0.1rem"
        />
      </div>
    </van-form>
    <!-- :disabled="Tool.isNull(form.remark)  :class=" 
        Tool.isNull(form.remark) ? 'disabled'
        : ''
      "" -->
    <van-button
      v-if="!empty"
      @click="save"
      type="info"
      style="
        width: calc(100% - 1.1rem);
        z-index: 1;
        margin: 0 0.55rem;
        bottom: 0.5rem;
        position: fixed;
        border: none;
      "
    >
      {{btnText}}
    </van-button>
  </div>
</template>
<script>
import refundData from '../../mock/refund'
import SelectPick from "../components/select-pick"
import { Field, Button, Form, Toast, Empty } from 'vant'
// import { expressCompanys } from '../../utils/expressJson'

export default {
  components: {
    [SelectPick.name]: SelectPick,
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [Empty.name]: Empty
  },
  data () {
    return {
      data: {},
      form: {},
      refundOrderId: '',
      orderId: '',
      btnText: '提交',
      empty: true
    }
  },
  created () {
    this.orderId = this.$route.query.orderId
    if (this.$route.query.type === '2' ) {
      this.btnText = '重新提交'
      this.getDetail(this.orderId)
    } else {
      this.tradeDetail(this.orderId)
    }
  },
  methods: {
    // async getDetail
    async tradeDetail (orderId) {
      let { data } = await this.$HTTP.ApiRefund.tradeDetailGet(orderId)
      // let { data } = refundData.refundDetail
      console.log('data' ,data)
      this.data = data
      this.data['refundFee'] = data.tradeFee
      this.empty = this.data.isEvaluate === 1 ? true : false
      // this.$set(this.form, 'refundReason', this.data.refundReason || '')
    },
    // 获取详细信息
    async getDetail (orderId) {
      let { data } = await this.$HTTP.ApiRefund.refundDetailGet(orderId)
      // let { data } = refundData.refundDetail
      console.log('data' ,data)
      this.data = data
      this.empty = this.data.isEvaluate === 1 ? true : false
      this.$set(this.form, 'refundReason', this.data.refundReason || '')
      // this.form = data
    },

    // 提交信息
    async save () {
      // await this.$refs['form'].validate()
      // Toast('fafdaf')
      if (this.$route.query.type === '2') {
        this.updateRefundApply()
      } else {
        this.applyRefund()
      }
    },

    // 新增退款申请
    async applyRefund () {
      try {
        await this.$HTTP.ApiRefund.applyRefundPost({...this.form, ...{ orderId: this.orderId }})
        Toast('提交成功')
        setTimeout(() => {
          this.$AppMethod.goBackNative()
        }, 1000)
      } catch (e) {
        // 
      }
    },

    // 修改申请
    async updateRefundApply () {
      try {
        await this.$HTTP.ApiRefund.updateRefundApplyPut({...this.form, ...{ refundOrderId: this.data.refundOrderId, orderId: this.orderId }})
        Toast('提交成功')
        setTimeout(() => {
          this.$AppMethod.goBackNative()
        }, 1000)
      } catch (e) {
        // 
      }
    }
  }
}
</script>
<style lang="less" scoped>
.refund-edit {
  padding-bottom: 60px;
  .empty {
    margin-top: 160px/2;
  }
}
.detail {
  position: relative;
  background: #77573A;
  padding: 48px/2 56px/2;
  .detail-tips-img {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
  }
  .icm-title {
    display: flex;
    font-size: 28px/2;
    color: #F8E7D2;
    margin-top: 10px/2;
    line-height: 40px/2;
    font-family: 'SourceHanSerifCN-Regular';

    .prefix-icon {
      margin-right: 8px/2;
      .icon-img {
        width: 32px/2;
        vertical-align: middle;
      }
    }
    .label-content {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-right: 60px/2;
    }
  }

  .icm-content {
    display: flex;
    margin: 24px/2 0 16px/2;
    justify-content: space-between;
    line-height: 58px/2;
    color: #F8E7D2;
    font-weight: bold;
    font-size: 40px/2;
    font-family: 'SourceHanSerifCN-Bold';
  }
}

.edit-form {
  .form-box {
    margin: 40px/2;
    background-color: #ffffff;
    padding: 32px/2;
    border-radius: 10px/2;
    opacity: 1;

    .icm-label {
      display: flex;
      justify-content: space-between;
      height: 80px/2;
      line-height: 80px/2;
      border-bottom: 1px solid #E5E5E5;
      font-size: 28px/2;
      font-weight: bold;
      .label {
        color: #908581;
      }
    }
  }
  

  .prefix-icon {
    width: 24px;
    vertical-align: middle;
  }
}
</style>